<template>
    <section class="cabinet__wrap">
        <div class="cabinet__row">
            <div class="cabinet__column cabinet__column--width-100">
                <h2 class="cabinet__title">История займов</h2>
            </div>
        </div>
        <div class="cabinet__row">
            <div class="cabinet__column cabinet__column--width-100">
                <div class="loan-history">
                    <ul class="loan-history__list">
                        <li class="loan-history__item" v-for="item in history">
                            <div class="loan-history__item-title" v-bind:class="{'loan-history__item-title--active': item.status === 'ACTIVE'}">
                                <span class="loan-history__item-name">Микрокредит</span>
                                <span class="loan-history__item-status">{{transformStatus(item.status)}}</span>
                            </div>
                            <div class="loan-history__item-info">
                                <div class="loan-history__row">
                                    <span class="loan-history__column-name">Выдан</span>
                                    <span class="loan-history__column-content">{{formatDate(item.issuedAt, 'DD MMMM YYYY')}}</span>
                                </div>
                                <div class="loan-history__row">
                                    <span class="loan-history__column-name">Дата погашения</span>
                                    <span class="loan-history__column-content">{{formatDate(item.expirationDate, 'DD MMMM YYYY')}}</span>
                                </div>
                                <div class="loan-history__row">
                                    <span class="loan-history__column-name">Сумма займа</span>
                                    <span class="loan-history__column-content">{{item.amount | ceil | numberFormat}} ₸</span>
                                </div>
                                <div class="loan-history__row">
                                    <span class="loan-history__column-name">Срок займа</span>
                                    <span class="loan-history__column-content">{{termFormat(item.term)}}</span>
                                </div>

                            </div>

                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import each from 'lodash/each';
    import StatusesTransformer from '@/modules/StatusesTransformer'
    import Helpers from '@/modules/Helpers'
    import moment from 'moment'

    moment.locale('ru');

    export default {
        name: 'loanHistory',
        metaInfo: {
            title: 'История займов'
        },
        data(){
            return {
                history: []
            }
        },
        methods:{
            transformStatus: function (status) {
                return StatusesTransformer.translateStatus(status);
            },
            formatDate: function (date, format) {
                return moment(date, 'DD.MM.YYYY').format(format);
            },
            termFormat: function (term) {
                return term + ' ' +Helpers.declension(['месяц','месяца','месяцев'], term);
            },
            haveHistory: function () {
                return history.length > 0;
            }
        },
        mounted(){
            let _this = this;
            this.$http.get('/json/credit?issued=true').then(
                (response) => {
                    if(response.data.code === 0){
                        each(response.data.data, function (item, index) {
                            _this.history.push(item);
                        });

                    }
                },
                (response) => {}
            )
        }
    }
</script>

<style lang="scss">
    @import "~@/assets/scss/variable";
    .loan-history{
        &__list{
            list-style-type: none;
        }
        &__item{
            border: 1px solid $gray;
            border-radius: 10px;
            overflow: hidden;
            box-shadow: 0 2px 6px 0 #DCDCDC;
        }
        &__item-title{
            display: flex;
            justify-content: space-between;
            padding:10px 15px;
            background: $gray;
            &--active{
                background: $yellow-site;
                .loan-history__item-name{
                    color: $white;
                    font-family: $RobotoRegular;
                }
                .loan-history__item-status{
                    color: $white;
                    font-family: $RobotoRegular;
                }
            }
        }
        &__item-name{
            color: $gray-dim-dark;
        }
        &__item-status{
            color: $gray-dim-dark;
        }
        &__item-info{
            background-color: #F8F8F8;
        }
        &__row{
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            padding: 5px 15px;
        }
        &__column-name{
            color: $gray-dim;
            font-size: 14px;
            font-family: $RobotoRegular;
        }
        &__column-content{
            color: $gray-dim-dark;
            font-size: 16px;
            font-family: $RobotoRegular;
        }
    }
</style>